import React, { ComponentProps } from 'react';
import { DialogModal } from './DialogModal';
import { t } from 'i18next';
import { AccessibleDialog } from 'src/components/Modals/components';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';
import MvpAppRejectModalMessage from 'src/components/Modals/Reject/MvpAppRejectModal/MvpAppRejectModalMessage';

type Props = ComponentProps<typeof DialogModal>;

const RejectDialog = ({
  onCancel,
  onConfirm,
  title = t('Confirmation'),
}: Props) => {
  const message: string = t(
    'IfYouRejectTheAgreementItWillBeDiscardedAndStoredInTheArchive'
  );
  const warning: string = t('AreYouSureYouWantToRejectTheAgreement');
  const isFromMvpApp = useUrlParameterCheck('/app');

  const dialogProps = {
    title,
    message,
    warning,
    onCancel,
    onConfirm,
  };

  return (
    <AccessibleDialog
      onConfirm={onConfirm}
      onCancel={onCancel}
      ariaLabel={t('AreYouSureYouWantToRejectTheAgreement')}
    >
      {isFromMvpApp ? (
        <MvpAppRejectModalMessage onConfirm={onConfirm} onCancel={onCancel} />
      ) : (
        <DialogModal {...dialogProps} data-testid="data-testid" />
      )}
    </AccessibleDialog>
  );
};

export default RejectDialog;
